<div
    [formGroup]="formGroup()"
    class="border-form-control primary-bg-100 rounded position-relative"
    [ngClass]="{
        'is-valid': formGroup().get(id()).valid && (formGroup().get(id()).dirty || formGroup().get(id()).touched),
        'is-invalid': formGroup().get(id()).invalid && (formGroup().get(id()).dirty || formGroup().get(id()).touched)
    }">
    <label
        class="position-absolute primary-bg-100 primary-text-200 px-1 font-4 form-label"
        [for]="id()"
        [id]="id() + '-label'">
        <span>
            {{ label() }}
            <span
                *ngIf="!readonly() && required()"
                class="text-red-500">
                *
            </span>
        </span>
    </label>

    <div class="row g-0">
        <input
            type="text"
            class="col p-3 bg-transparent border-0 primary-text w-100"
            [id]="id()"
            [maxlength]="maxLength()"
            [formControlName]="id()"
            [attr.required]="required() ? true : null"
            [attr.readonly]="readonly() ? true : null"
            [attr.autofocus]="focus() ? true : null"
            [tooltip]="readonly() ? formGroup().get(id())?.value : null" />

        <div
            class="col-auto d-flex align-items-center"
            *ngIf="readonly()">
            <span class="material-icons-sharp primary-text me-2">lock_open</span>
        </div>
    </div>
</div>
